import { AUTHOR_IDENTITY_HASH_DOMAIN } from '@cf-shared/data-model/exercise';

// Per-author SHA-256 used by the coach-channel filter. Asymmetric with the server: server
// uses Node `crypto.createHash` (sync) at server/functions/src/helpers/author-identity-hash.ts;
// client uses Web Crypto's `crypto.subtle.digest` (async). Both share the
// `AUTHOR_IDENTITY_HASH_DOMAIN` prefix so a known uid produces the same hex on both sides.
//
// Do NOT wrap the server helper in a Promise to "match" — the asymmetry is intentional and
// the bundlers can't reach Node's `crypto` from the client.
export async function computeAuthorIdentityHashAsync(uid: string): Promise<string> {
  const buf = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(AUTHOR_IDENTITY_HASH_DOMAIN + uid),
  );
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
